<template>
    <div>
        <div class="pricing-details p-3 bg-lightest">
            <table class="table bare details">
                <tr>
                    <td class="bold">Taxes</td>
                    <td>
                        {{ formatPrice(taxesPriceTotal + extrasTaxPriceTotal) }}€

                        <span v-if="product.includeTaxes">(included)</span>
                    </td>
                </tr>

                <!-- <tr>
                    <td class="bold">Commission ({{ commissionPercentage }}%)</td>
                    <td>{{ commission }}€</td>
                </tr> -->
            </table>
        </div>

        <div class="totals bg-color-1 py-3 mb-3">
            <table class="table bare">
                <tr>
                    <td>Total</td>

                    <td class="bold fs-largest">
                        {{ formatPrice(finalPrice) }}€
                    </td>
                </tr>
                <tr v-if="chosenPayment && chosenPayment.id !== 1 && chosenDeposit">
                    <td>Deposit</td>

                    <td class="fs-large">
                        <span v-if="chosenDeposit.id > 0">
                            {{ formatPrice(product.paymentValue) }}€
                        </span>
                        <span v-else>
                            {{ product.paymentValue }}% ({{ formatPrice(deposit) }}€)
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>Outstanding amount</td>

                    <td class="fs-large">
                        {{ formatPrice(outstanding) }}€
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [reservationsMixin],
        props: {
            reservation: Object,
            product: Object,
            chosenDeposit: Object,
            chosenPayment: Object,
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .pricing-details {
        border-left: 1px solid $light;
        border-right: 1px solid $light;
    }

    .totals {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;

        .table {
            width: 86%;
            margin: 0 7%;
            background: transparent;

            td {
                color: $lightest;
                vertical-align: middle;
                padding: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// SummaryTotals.vue?584400cf